import { Injectable } from '@angular/core';

/**
 * Web-only refresh token persistence for operator-panel.
 *
 * MVP: localStorage.
 *
 * NOTE: For higher security, consider using an HttpOnly cookie or
 * browser storage hardening + short refresh TTL.
 */
@Injectable({ providedIn: 'root' })
export class RefreshTokenStore {
  private readonly key = 'eldara.operator.refreshToken';

  async get(): Promise<string | null> {
    try {
      const v = localStorage.getItem(this.key);
      return v && v.trim().length ? v : null;
    } catch {
      return null;
    }
  }

  async set(token: string): Promise<void> {
    try {
      localStorage.setItem(this.key, token);
    } catch {
      // ignore
    }
  }

  async clear(): Promise<void> {
    try {
      localStorage.removeItem(this.key);
    } catch {
      // ignore
    }
  }
}
